// eslint-disable-next-line import/prefer-default-export
export const GROUPPOSTS_SELECTOR_KEY = 'groupposts';
